import { useCallback } from 'react'
import { ReactFCC } from '@/types/react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'

interface TorchAgesProps {
  disabled?: boolean
  value?: string[]
  name: string
  onChange: ({ name, value }: { name: string; value: string[] }) => void
}

export const TorchAges: ReactFCC<TorchAgesProps> = ({ disabled, value, name, onChange }) => {
  const { t } = useTranslate('guild-create')
  const ages = [
    { label: t('ages1to2', '1-2'), value: '1-2' },
    { label: t('ages3to5', '3-5'), value: '3-5' },
    { label: t('ages6to8', '6-8'), value: '6-8' },
    { label: t('ages9to12', '9-12'), value: '9-12' },
    { label: t('ages13to17', '13-17'), value: '13-17' },
  ]

  const handleChange = useCallback(
    (value: string[]) => {
      onChange({ name, value })
    },
    [name, onChange],
  )

  return (
    <OptionGroup
      label={t('whatAgeIsTheTargetAudience', 'What age is the target audience?')}
      options={ages}
      required
      disabled={disabled}
      name={name}
      value={value || []}
      onChange={handleChange}
    />
  )
}
